import React from 'react'

import Botao from '../../../../Mantine/Botao/index.jsx'
import Group from '../../../../Mantine/Group/index.jsx'
import Modal from '../../../../Mantine/Modal/index.jsx'

import * as S from './styles.js'

const MESSAGES = {
  PARTIAL_REMOVED: `Uma ou mais linhas foram removidas porque não possuem dados para a localização da antena.
    As linhas selecionadas restantes serão exibidas em portadoras.`,
  NO_DATA: `Nenhuma das linhas selecionadas possuem dados para a localização da antena.`
}

export default function AlertaSimcardReTAmovido({ onClick, opened, hasData }) {
  const message = hasData ? MESSAGES.PARTIAL_REMOVED : MESSAGES.NO_DATA

  return (
    <div>
      <Modal
        titulo="Atenção!"
        width="600px"
        type="alerta"
        opened={opened}
        positionTitle="center"
      >
        <S.ModalAlert>
          <p className="modal-alert">{message}</p>
          <Group position="center">
            <Botao label="Fechar" variant="outline" onClick={onClick} />
          </Group>
        </S.ModalAlert>
      </Modal>
    </div>
  )
}
